import { render, staticRenderFns } from "./ConsignorSelect.vue?vue&type=template&id=56688a62&scoped=true"
import script from "./ConsignorSelect.vue?vue&type=script&lang=js"
export * from "./ConsignorSelect.vue?vue&type=script&lang=js"
import style0 from "./ConsignorSelect.vue?vue&type=style&index=0&id=56688a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56688a62",
  null
  
)

export default component.exports